import React from "react";

function HearroDashboardPage() {
    return (
        <div className="dashboardContent">
            <div className="dashboardContent__title">
                <span className="dashboardContent__title__content">
                    Dashboard
                </span>
            </div>
            <div className="Dashboard-Content" />
        </div>
    );
}

export default HearroDashboardPage;